var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_vm.badgeValue && _vm.badgeValue.value)?_c('el-badge',_vm._b({staticClass:"badge"},'el-badge',_vm.badgeValue,false),[_vm._t("default")],2):_c('span',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }